(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["short-description"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-short-description-link]');
    if (!link) return;

    const href = link.getAttribute('href')?.trim();
    if (!href?.startsWith('#')) return;

    const targetId = href.slice(1);
    let target = document.getElementById(targetId);

    if (!target) {
      target = [...document.querySelectorAll('h2')].find((heading) =>
        heading.textContent.trim().toLowerCase().includes('product description')
      );
    }

    if (!target) return;

    event.preventDefault();

    const headerHeight =
      parseInt(getComputedStyle(document.body).getPropertyValue('--header-group-height'), 10) || 0;

    const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });

    history.replaceState(null, '', href);
  });
  } catch(e) { console.error(e); }
})();

})();
